
/**
 * Converts a Base64 encoded image string to a Blob object.
 * @param base64Image String representing image base 64.
 * @param contentType - contentType of the image, default is 'image/png'
 * @returns Blob object representing the image.
 */

function convertBase64ToBlob(base64Image: string, contentType: string = 'image/png'): Blob {
    
    if (!base64Image) {
        throw new Error('Base64 image string is empty.');
    }

    // Check if the string contains a header (data:*/*;base64,)
    let base64String = base64Image;
    const commaIndex = base64Image.indexOf(',');
    if (commaIndex !== -1) {
        base64String = base64Image.substring(commaIndex + 1);
    }

    // Validate base64 string (should only contain valid base64 characters)
    if (!/^([A-Za-z0-9+/=]+)$/.test(base64String)) {
        throw new Error('Invalid Base64 string.');
    }

    let binaryData;
    try {
        binaryData = atob(base64String);
    } catch (e) {
        throw new Error('Failed to decode Base64 string.');
    }
    const byteNumbers = new Uint8Array(binaryData.length);
    for (let j = 0; j < binaryData.length; j++) {
        byteNumbers[j] = binaryData.charCodeAt(j);
    }
    return new Blob([byteNumbers], { type: contentType });
}

export default convertBase64ToBlob;